import { Link } from "react-router-dom";
import { ArrowUpRight, BadgeCheck, Sparkles } from "lucide-react";

const U = (id, w = 900) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const DESTINATIONS = [
  { name: "California", tag: "Redwoods & cliffs", img: U("1661758956648-5afc2f7f4626") },
  { name: "Florida", tag: "Overwater sunsets", img: U("1622603720676-6d957673e8b3") },
  { name: "North Carolina", tag: "Dunes & treehouses", img: U("1669130391362-b202f3cb7755") },
  { name: "Nevada", tag: "Lake Tahoe cabins", img: U("1790954224316-f16a72639bb1") },
  { name: "Illinois", tag: "Skyline lofts", img: U("1672082497059-1e6c0209eeeb") },
];

const MARQUEE = ["Big Sur", "Key West", "Lake Tahoe", "Outer Banks", "Asheville", "Malibu", "Cape May", "Chicago"];

export function ReceiptCard() {
  return (
    <div className="float-slow w-72 rounded-3xl border border-white/30 bg-white/15 p-5 text-white shadow-2xl backdrop-blur-xl" data-testid="hero-receipt-card">
      <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-emerald-200"><Sparkles className="h-3.5 w-3.5" />3 nights · Big Sur</p>
      <div className="mt-4 space-y-2 text-sm">
        <div className="flex justify-between"><span className="text-white/80">Nightly × 3</span><span className="font-mono-num">$567.00</span></div>
        <div className="flex justify-between"><span className="text-white/80">Cleaning</span><span className="font-mono-num">$60.00</span></div>
        <div className="flex justify-between"><span className="text-white/80">Service fee</span><span className="font-mono-num text-emerald-300">$0.00</span></div>
      </div>
      <div className="mt-4 flex items-end justify-between border-t border-white/25 pt-3">
        <div>
          <p className="text-xs text-white/70">Total before local lodging tax</p>
          <p className="font-display text-3xl font-bold">$627</p>
        </div>
        <span className="rounded-full bg-emerald-400 px-3 py-1 text-xs font-bold text-emerald-950">$0 guest fee</span>
      </div>
    </div>
  );
}

export function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="marquee overflow-hidden border-y border-stone-900 bg-secondary py-4 text-white" data-testid="destinations-marquee">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((d, i) => (
          <span key={`${d}-${i < MARQUEE.length ? "a" : "b"}`} className="flex items-center gap-10 font-display text-2xl font-bold uppercase tracking-tight sm:text-3xl">
            {d}<span className="text-stone-900">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}

const STATS = [
  ["$0", "guest service fee, ever"],
  ["10%", "flat host commission"],
  ["~$55", "less in host fees per $1,000 vs Airbnb's typical 15.5% (est.)"],
  ["100%", "listings permit-checked & insured"],
];

export function StatsBand() {
  return (
    <div className="grid grid-cols-2 gap-px overflow-hidden rounded-[2rem] bg-stone-800 lg:grid-cols-4" data-testid="landing-stats">
      {STATS.map(([v, l]) => (
        <div key={l} className="bg-stone-900 p-8 transition-colors duration-300 hover:bg-stone-950">
          <p className="font-display text-4xl font-bold text-emerald-300 sm:text-5xl">{v}</p>
          <p className="mt-2 text-sm text-stone-400">{l}</p>
        </div>
      ))}
    </div>
  );
}

export function DestinationTiles() {
  return (
    <div className="grid auto-rows-[220px] gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="destination-tiles">
      {DESTINATIONS.map((d, i) => (
        <Link key={d.name} to={`/search?location=${encodeURIComponent(d.name)}`} data-testid={`destination-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
          className={`group relative overflow-hidden rounded-3xl ${i === 0 ? "sm:col-span-2 sm:row-span-2" : ""}`}>
          <img src={d.img} alt={d.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-stone-950/10 to-transparent" />
          <div className="absolute inset-x-5 bottom-5 flex items-end justify-between text-white">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-200">{d.tag}</p>
              <p className={`font-display font-bold ${i === 0 ? "text-4xl" : "text-2xl"}`}>{d.name}</p>
            </div>
            <span className="grid h-10 w-10 place-items-center rounded-full bg-white text-stone-900 transition-transform duration-300 group-hover:-rotate-45"><ArrowUpRight className="h-5 w-5" /></span>
          </div>
        </Link>
      ))}
    </div>
  );
}

export const TrustChips = () => (
  <div className="flex flex-wrap gap-2">
    {["Permit-checked homes", "Insured hosts", "Real people review complaints"].map((t) => (
      <span key={t} className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-medium text-white backdrop-blur-md">
        <BadgeCheck className="h-3.5 w-3.5 text-emerald-300" />{t}
      </span>
    ))}
  </div>
);
